// extracted by mini-css-extract-plugin
module.exports = {"instagram-user-card":"Instagram_instagram-user-card__3BV9v","instagram-user-media":"Instagram_instagram-user-media__2L1p5"};